export function cleanRegExp(value = ''): string {
  return value.replaceAll(/[?().{}[\]+*\\$^]/gi, '');
}
